export default "__VITE_ASSET__BiEuEnoc__"